






























import { Component, Vue, Mixins } from 'vue-property-decorator'
import ContentLayout from '@/apps/open/layout/ContentLayout.vue'
import { onRequestError } from '@/apps/open/utils'
import Button from '@components/Button'
import { ElForm } from 'element-ui/types/form'
import { getCallbackInfo, updateCallbackInfo } from '@/apps/open/services/app'
import { priUrlReg } from '@/apps/open/constants'

@Component({
  components: {
    ContentLayout,
    Button
  }
})
export default class Callback extends Vue {
  form = {
    cb_domain: '',
    auth: '',
    setting: '',
    notify: ''
  }

  loading: boolean = false

  $refs!: {
    form: ElForm
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get rules () {
    const urlReg = new RegExp(priUrlReg, 'i')
    const urlRule = this.isPrivate ? { pattern: urlReg, message: '请输入正确的回调域名', trigger: ['blur', 'change'] } : { type: 'url', message: '请输入正确的回调域名', trigger: ['blur', 'change'] }
    return {
      cb_domain: [
        { required: true, message: '请填写回调域名', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] },
        urlRule
      ],
      auth: [
        { required: true, message: '请填写用户认证', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
      ],
      setting: [
        { required: true, message: '请填写用户授权与水印', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
      ],
      notify: [
        { required: true, message: '请填写回调通知', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
      ]
    }
  }

  isEdit: boolean = false

  get appId () {
    return this.$route.params.id
  }

  mounted () {
    this.getCallbackInfo()
  }

  saveCallbackConfig () {
    this.$refs.form.validate(async (valid: boolean) => {
      if (valid) {
        const params = {
          callback_domain: this.form.cb_domain,
          user_auth: this.form.auth,
          user_setting: this.form.setting,
          callback_notify: this.form.notify
        }
        const res = await updateCallbackInfo(this.appId, params)
        if (res.data.result === 'ok') {
          this.$message.success('更新成功')
        }
      }
    })
  }

  async getCallbackInfo () {
    const res = await getCallbackInfo(this.appId)
    if (res.data.result === 'ok') {
      const info = res.data.object
      this.form = {
        cb_domain: info.callback_domain,
        auth: info.user_auth,
        setting: info.user_setting,
        notify: info.callback_notify
      }
    }
  }
}
